export class Locale {
  idLocale: number;
  idLanguage: number;
  idCountry: number | null;
  formatDate: string | null;
  formatTime: string | null;
  formatNumber: string | null;
  formatAddress: string | null;
  formatTelephone: string | null;
  metric: string | null;
  collation: string | null;
  firstWeekDay: number | null;
  timezone: string | null;
  locked: boolean;

  constructor(
    idLocale: number,
    idLanguage: number,
    idCountry: number | null,
    formatDate: string | null,
    formatTime: string | null,
    formatNumber: string | null,
    formatAddress: string | null,
    formatTelephone: string | null,
    metric: string | null,
    collation: string | null,
    firstWeekDay: number | null,
    timezone: string | null,
    locked: boolean,
  ) {
    this.idLocale = idLocale;
    this.idLanguage = idLanguage;
    this.idCountry = idCountry;
    this.formatDate = formatDate;
    this.formatTime = formatTime;
    this.formatNumber = formatNumber;
    this.formatAddress = formatAddress;
    this.formatTelephone = formatTelephone;
    this.metric = metric;
    this.collation = collation;
    this.firstWeekDay = firstWeekDay;
    this.timezone = timezone;
    this.locked = locked;
  }

  static fromRaw(raw: any): Locale {
    return new Locale(
      Number(raw.idLocale),
      Number(raw.idLanguage),
      raw.idCountry !== undefined && raw.idCountry !== null ? Number(raw.idCountry) : null,
      raw.formatDate != null ? String(raw.formatDate) : null,
      raw.formatTime != null ? String(raw.formatTime) : null,
      raw.formatNumber != null ? String(raw.formatNumber) : null,
      raw.formatAddress != null ? String(raw.formatAddress) : null,
      raw.formatTelephone != null ? String(raw.formatTelephone) : null,
      raw.metric != null ? String(raw.metric) : null,
      raw.collation != null ? String(raw.collation) : null,
      raw.firstWeekDay !== undefined && raw.firstWeekDay !== null ? Number(raw.firstWeekDay) : null,
      raw.timezone != null ? String(raw.timezone) : null,
      Boolean(raw.locked),
    );
  }

  clone(): Locale {
    return new Locale(
      this.idLocale,
      this.idLanguage,
      this.idCountry,
      this.formatDate,
      this.formatTime,
      this.formatNumber,
      this.formatAddress,
      this.formatTelephone,
      this.metric,
      this.collation,
      this.firstWeekDay,
      this.timezone,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idLocale: this.idLocale,
      idLanguage: this.idLanguage,
      locked: this.locked,
    };
    if (this.idCountry !== null) payload.idCountry = this.idCountry;
    if (this.formatDate !== null) payload.formatDate = this.formatDate;
    if (this.formatTime !== null) payload.formatTime = this.formatTime;
    if (this.formatNumber !== null) payload.formatNumber = this.formatNumber;
    if (this.formatAddress !== null) payload.formatAddress = this.formatAddress;
    if (this.formatTelephone !== null) payload.formatTelephone = this.formatTelephone;
    if (this.metric !== null) payload.metric = this.metric;
    if (this.collation !== null) payload.collation = this.collation;
    if (this.firstWeekDay !== null) payload.firstWeekDay = this.firstWeekDay;
    if (this.timezone !== null) payload.timezone = this.timezone;
    return payload;
  }
}
